module.exports = __webpack_public_path__ + "static/media/sleepwell_color.24ccd8f9.jpg";